export default __webpack_public_path__ + "static/media/hp-plans-oscer-crown.46141f00.svg";